import './DoodleSpinner.css'
import { COLORS } from '../theme'

interface DoodleSpinnerProps {
  color?: string
}

export default function DoodleSpinner({ color = COLORS.primary }: DoodleSpinnerProps) {
  return (
    <svg
      className="doodle-spinner"
      viewBox="-5 -35 435 225"
      style={{ '--doodle-color': color } as React.CSSProperties}
      aria-hidden="true"
    >
      {/* Path 1: Top forearm → thumb → knuckle 1 loop */}
      <path
        className="doodle-arm"
        pathLength={1}
        d="M 5.4,67.4 C 52.6,67.4 239.1,67.8 288.2,67.3 C 300,67 312,58 319.4,46.0 C 321,38 324,25 325.0,21.3 C 326.7,15.3 327.7,12.9 329.7,10.1 C 331.7,7.3 334.7,5.6 337.0,4.6 C 339.2,3.6 340.8,3.5 343.1,3.9 C 345.3,4.3 348.3,5.2 350.3,6.8 C 352.3,8.5 354.1,9.3 354.9,13.8 C 355.8,18.3 355.3,28.3 355.3,33.8 C 355.3,39.2 355.4,42.5 355.0,46.4 C 354.5,50.4 353.4,54.3 352.7,57.3 C 351.9,60.4 351.5,62.3 350.7,64.8 C 349,70 348,76 349,72 C 350,66 350,62 351.6,60.1 C 354.0,58.7 354.8,59.0 362.1,59.7 C 369.5,60.3 388.6,62.7 396.0,63.8 C 403.3,64.9 403.1,64.8 406.3,66.2 C 409.6,67.7 413.3,69.5 415.5,72.4 C 417.8,75.4 419.4,80.2 420.0,84.1 C 420.6,88.1 419.8,92.7 419.1,96.4 C 418.5,100.1 417.9,103.4 416.0,106.1 C 414.1,108.8 411.2,110.9 407.7,112.8 C 404.3,114.6 399.7,116.4 395.2,117.0 C 390.8,117.6 385.3,116.6 381.0,116.3 C 376.6,116.1 372.3,116.1 369.1,115.6 C 366.0,115.0 364.2,114.8 361.9,113.0 C 359.7,111.2 356.6,107.7 355.6,104.8 C 354.5,101.9 355.3,98.4 355.6,95.7 C 356.0,93.0 356.0,90.9 357.7,88.7 C 359.4,86.6 362.6,84.2 365.8,82.9 C 369.0,81.6 372.5,81.4 377.2,81.1 C 381.8,80.8 390.1,81.1 393.9,81.2 C 397.7,81.3 399.0,81.5 400.1,81.5"
      />

      {/* Path 2: Knuckle 2 loop */}
      <path
        className="doodle-knuckle doodle-knuckle--2"
        pathLength={1}
        d="M 417.0,110.7 C 417.2,112.0 418.0,116.1 418.0,118.8 C 418.0,121.4 417.9,124.1 416.9,126.6 C 415.9,129.1 414.7,131.7 412.2,133.7 C 409.6,135.7 406.1,137.7 401.7,138.5 C 397.3,139.3 390.5,138.5 385.9,138.4 C 381.3,138.2 377.7,138.1 374.2,137.8 C 370.8,137.4 367.7,136.9 365.2,136.2 C 362.6,135.5 360.7,135.2 359.0,133.7 C 357.4,132.2 355.9,129.3 355.1,127.2 C 354.3,125.0 354.1,123.0 354.5,120.8 C 354.9,118.7 356.9,115.3 357.3,114.2"
      />

      {/* Path 3: Knuckle 3 loop */}
      <path
        className="doodle-knuckle doodle-knuckle--3"
        pathLength={1}
        d="M 414.1,133.3 C 414.4,134.6 415.7,138.5 415.9,141.2 C 416.1,144.0 416.0,147.3 415.2,149.7 C 414.4,152.1 413.2,154.1 411.1,155.6 C 408.9,157.1 405.5,158.0 402.2,158.6 C 398.9,159.2 394.7,159.3 391.2,159.3 C 387.7,159.4 384.5,158.9 381.2,158.8 C 377.9,158.7 374.8,159.6 371.3,158.9 C 367.9,158.1 363.0,155.9 360.7,154.3 C 358.4,152.6 358.1,150.9 357.4,149.0 C 356.7,147.1 355.8,144.6 356.3,142.7 C 356.8,140.8 359.6,138.5 360.3,137.7"
      />

      {/* Path 4: Knuckle 4 loop → bottom forearm */}
      <path
        className="doodle-return"
        pathLength={1}
        d="M 406.7,158.2 C 407.1,159.7 409.3,164.1 408.8,166.9 C 408.3,169.6 406.4,172.8 403.9,174.6 C 401.4,176.4 397.5,177.2 394.0,177.8 C 390.4,178.5 386.3,178.5 382.5,178.6 C 378.7,178.7 374.6,178.9 371.2,178.4 C 367.8,177.9 364.3,176.9 362.1,175.5 C 359.9,174.2 359.0,172.4 358.2,170.2 C 357.3,168.1 356.4,165.2 356.9,162.7 C 357.4,160.2 360.8,155.3 361.1,155.4 C 361.3,155.6 358.9,161.3 358.3,163.6 C 357.7,166.0 357.7,168.5 357.5,169.8 C 357.2,171.0 358.4,170.8 356.8,171.3 C 355.2,171.8 350.9,172.6 347.6,172.7 C 344.2,172.9 340.3,173.1 336.7,172.2 C 333.1,171.4 329.6,169.4 326.1,167.6 C 322.7,165.9 319.1,163.3 315.8,161.7 C 312.5,160.1 310.5,158.8 306.3,158.0 C 301.0,157.5 296.0,157.0 291.0,156.9 L 4.6,157.2"
      />

      {/* 3 spark rays — offset from thumb tip at (343, 3.9) */}
      <line className="doodle-spark doodle-spark--1" pathLength={1} x1="343" y1="-16" x2="343" y2="-30" />
      <line className="doodle-spark doodle-spark--2" pathLength={1} x1="335" y1="-11" x2="325" y2="-25" />
      <line className="doodle-spark doodle-spark--3" pathLength={1} x1="351" y1="-11" x2="361" y2="-25" />
    </svg>
  )
}
